import BaseAPI from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";
import { temperatureLocationRoute } from "../routes";

export default class TemperatureLocationAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, temperatureLocationRoute, "temperature-location");
    }

    async Add(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("add", result.id);
        return result;
    }

    async Update(id, data) {
        const result = await this._request("put", this._url(`/${id}`), data);
        this._emit("update", result.id);
        return result;
    }

    async Delete(id) {
        const result = await this._request("delete", this._url(`/${id}`));
        this._emit("delete", id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request(
            "post",
            `${getAPIUrlV2("temperature/control/temperature-locations")}/mark-archived?id=${id}`
        );
        this._emit("mark-archived", id);
        return result;
    }
}
